import React from "react";
import type { WindowPosition } from "@poscon/shared-frontend";
import { MetarRow } from "components/WxReport";

export const MetarTearoff = ({ airport, pos }: { airport: string; pos: WindowPosition }) => {
  return <MetarRow stationCode={airport} x={pos.x} y={pos.y} asTearoff />;
};
